export enum EUnitOfMeasureMetricLabel {
    meter = 'm',
    meterPerSecond = 'm/s',
    power  = 'kW',
}

export enum EUnitOfMeasureImperialLabel {
    feet = 'ft',
    inch = 'in',
    feetPerSecond = 'ft/s',
    power  = 'kW',
}

export enum EUnitOfMeasureLabel{
    percentage = '%',
    deg= 'deg'
}
